import { render, staticRenderFns } from "./tableActions.vue?vue&type=template&id=c85faf12"
import script from "./tableActions.vue?vue&type=script&lang=js"
export * from "./tableActions.vue?vue&type=script&lang=js"
import style0 from "./tableActions.vue?vue&type=style&index=0&id=c85faf12&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports